/**
 * OpenAI Adapter — INTERFACE ONLY. No SDK, no network, no API key.
 *
 * When OpenAI is integrated, this is the ONLY file that needs code:
 *
 *   1. `yarn add openai` (or use fetch directly)
 *   2. Route the request through the admin proxy at
 *      /api/admin/ai-generator/generate, which attaches the server-side key.
 *      Do NOT read a REACT_APP_*_API_KEY here: CRA inlines those into the
 *      browser bundle, so the key would ship to every visitor.
 *      designV2/openai/provider.js is the working example.
 *   3. Implement generate() as sketched below
 *   4. registerProvider(new OpenAIAdapter({ apiKey })) — the Playground's
 *      provider dropdown picks it up automatically via isReady()
 *
 * generate() implementation sketch (DO NOT uncomment until the SDK exists):
 *
 *   async generate(prompt, context) {
 *     const completion = await this.client.chat.completions.create({
 *       model: this.model,
 *       messages: [
 *         { role: 'system', content: prompt.system },
 *         ...context.toPayload(),
 *         { role: 'user', content: prompt.user },
 *       ],
 *       tools: prompt.functions.map((f) => ({ type: 'function', function: f })),
 *       tool_choice: { type: 'function', function: { name: prompt.functionCall.name } },
 *     });
 *     const call = completion.choices[0].message.tool_calls?.[0];
 *     return {
 *       type: 'function_call',
 *       name: call.function.name,
 *       arguments: JSON.parse(call.function.arguments),
 *       usage: completion.usage,
 *     };
 *   }
 */

import { AIProvider, NotImplementedError } from '../providerInterface';

export class OpenAIAdapter extends AIProvider {
  constructor({ apiKey = null, model = 'gpt-4o' } = {}) {
    super({
      id: 'openai',
      name: 'OpenAI (not connected)',
      capabilities: { functionCalling: true, streaming: true, offline: false },
    });
    this.apiKey = apiKey;
    this.model = model;
  }

  isReady() {
    return false; // flips to Boolean(this.apiKey && this.client) once implemented
  }

  async generate() {
    throw new NotImplementedError(
      'OpenAI is not connected yet. Install the SDK, provide an API key, and implement OpenAIAdapter.generate() — see the sketch at the top of adapters/openaiAdapter.js and README.md.'
    );
  }
}
